module.exports = __webpack_public_path__ + "img/49E3FBC8-E2B1-4B18-8986-1078E9AD47A0_1_201_a-min.90d07d8b.jpeg";